module.exports = __webpack_public_path__ + "img/profile-pic.68bb9c27.webp";